import { CartItem } from '../../types/figs'

import { CheckoutLineItemInput, CustomAttribute } from './interfaces'

export function mapPropertiesToCustomAttributes(
  properties: CartItem['properties']
): CustomAttribute[] {
  return Object.entries(properties)
    .filter((p): p is [string, string] => typeof p[1] === 'string' && p[1] !== '')
    .map(([key, value]) => ({
      key: key,
      value: value,
    }))
}

export function mapCartItemToCheckoutLineItemInput(
  variantId: string,
  quantity: number,
  properties?: CartItem['properties']
): CheckoutLineItemInput {
  return {
    customAttributes: mapPropertiesToCustomAttributes(properties ?? {}),
    quantity,
    variantId,
  }
}

export function mapFigsCartItemsToShopifyCheckoutItems(
  figsCartItems: CartItem[]
): CheckoutLineItemInput[] {
  return figsCartItems
    .map(o => {
      return mapCartItemToCheckoutLineItemInput(o.variantId, o.quantity, {
        ...o.properties,
      })
    })
    .flat()
}
